  <template>
  <div class="general-wrapper">
    <Header parent="stickers_gallery">
      <template #title>
          {{ $t("stickers_checkout.title") }}
      </template>
    </Header>
      
    <PageContainer>
      <StickersCheckCard />
    </PageContainer>
  </div>
</template>
<script>
import StickersCheckCard from "@/components/StickersCheckCard.vue";
export default {
  components: {
    StickersCheckCard,
  },
};
</script>
